import { AutoMap } from "@automapper/classes";

export class SamplingPoint {

    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: string;
    @AutoMap()
    Address!: string;
    @AutoMap()
    City!: string;
    @AutoMap()
    ZipCode!: string;

    static mapFromJSON(json: any): SamplingPoint {
        const s = new SamplingPoint();

        s.Address = json.address;
        s.City = json.city;
        s.ZipCode = json.zipCode;
        s.Code = json.samplingPointCode;
        s.Name = json.samplingPointName;

        return s;
    }
}
